/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AttachPhoto } from '../models/AttachPhoto';
import type { Base64Image } from '../models/Base64Image';
import type { Body_create_new_image_form_api_v1_images_new_post } from '../models/Body_create_new_image_form_api_v1_images_new_post';
import type { ImageInfo } from '../models/ImageInfo';
import type { PhotoToInsert } from '../models/PhotoToInsert';
import type { ReorderImages } from '../models/ReorderImages';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class ImagesService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Serve Image
     * @returns string Successful Response
     * @throws ApiError
     */
    public serveImageApiV1ServeUuidGet({
        uuid,
        imagesToken,
    }: {
        uuid: string,
        imagesToken?: string,
    }): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/serve/{uuid}',
            path: {
                'uuid': uuid,
            },
            query: {
                'images_token': imagesToken,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Serve Thumbnail
     * @returns string Successful Response
     * @throws ApiError
     */
    public serveThumbnailApiV1ServeThumbsWXHUuidGet({
        uuid,
        w,
        h,
        imagesToken,
    }: {
        uuid: string,
        w: string,
        h: string,
        imagesToken?: string,
    }): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/serve/thumbs/{w}x{h}/{uuid}',
            path: {
                'uuid': uuid,
                'w': w,
                'h': h,
            },
            query: {
                'images_token': imagesToken,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List All Images
     * List metadata for every image stored in the system.
     * @returns ImageInfo Successful Response
     * @throws ApiError
     */
    public listAllImagesApiV1ImagesListGet(): CancelablePromise<Array<ImageInfo>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/images/list',
        });
    }
    /**
     * Reorder Object Images
     * Set the display order for images on an object by providing the full ordered list of UUIDs.
     * @returns any Successful Response
     * @throws ApiError
     */
    public reorderObjectImagesApiV1ImagesOrderObjectIdPut({
        objectId,
        requestBody,
    }: {
        objectId: number,
        requestBody: ReorderImages,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/v1/images/order/{object_id}',
            path: {
                'object_id': objectId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Detach Image From Object
     * Remove the association between an image and an object. The image file is preserved.
     * @returns any Successful Response
     * @throws ApiError
     */
    public detachImageFromObjectApiV1ImagesDetachObjectIdImageUuidDelete({
        objectId,
        imageUuid,
    }: {
        objectId: number,
        imageUuid: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/v1/images/detach/{object_id}/{image_uuid}',
            path: {
                'object_id': objectId,
                'image_uuid': imageUuid,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Image As Base64
     * @returns Base64Image Successful Response
     * @throws ApiError
     */
    public getImageAsBase64ApiV1ImagesUuidBase64Get({
        uuid,
    }: {
        uuid: string,
    }): CancelablePromise<Base64Image> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/images/{uuid}/base64',
            path: {
                'uuid': uuid,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Serve Image
     * @returns string Successful Response
     * @throws ApiError
     */
    public serveImageApiV1ImagesUuidGet({
        uuid,
    }: {
        uuid: string,
    }): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/images/{uuid}',
            path: {
                'uuid': uuid,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create New Image
     * Create an image from a base64-encoded JSON body. Returns the image UUID.
     * @returns string Successful Response
     * @throws ApiError
     */
    public createNewImageApiV1ImagesPut({
        requestBody,
    }: {
        requestBody: PhotoToInsert,
    }): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/v1/images/',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create New Image Form
     * Create an image from a multipart form upload. Returns the image UUID.
     * @returns string Successful Response
     * @throws ApiError
     */
    public createNewImageFormApiV1ImagesNewPost({
        formData,
    }: {
        formData: Body_create_new_image_form_api_v1_images_new_post,
    }): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/images/new',
            formData: formData,
            mediaType: 'application/x-www-form-urlencoded',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Attach Existing Image To Object
     * Attach (duplicate) or move an existing image to another object.
     * @returns string Successful Response
     * @throws ApiError
     */
    public attachExistingImageToObjectApiV1ImagesAttachPut({
        requestBody,
    }: {
        requestBody: AttachPhoto,
    }): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/v1/images/attach',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
